export default __webpack_public_path__ + "static/media/FL_PALM_Site_Logo.00ea79c9.png";